import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import { SectionLayout } from 'components/Sections/SectionLayout';
import CallToActionCards from 'components/CallToActionCards';
import StyledRichText from 'components/RichText/StyledRichText';
import useGlobalFooter from 'hooks/useGlobalFooter';
import useGlobalHeader from 'hooks/useGlobalHeader';
import WebsiteLayout from '../layouts/websiteLayout';
import SEO, { createSEO } from '../components/SEO';
import MagazineDownload from '../components/MagazineDownload';
import { STSubscribeForm } from '../components/Form/STSubscribeForm';

const PressDetailsTemplate = props => {
  const { edges } = props.data.allContentfulPress;
  const header = useGlobalHeader();
  const footer = useGlobalFooter();

  const { postTitle, content, postDate } = props.data.contentfulPress;

  const seo = createSEO(
    {
      ...props.data.contentfulPress,
      pageCategory: 'Press',
    },
    props
  );

  return (
    <WebsiteLayout header={header} footer={footer}>
      <SEO {...seo} />
      <SectionLayout backgroundColor="white">
        <PressDetails>
          <Row className="section-press-details-titles" gutter={100} type="flex">
            <Col lg={16} md={16} sm={16} xs={24}>
              <h1 className="section-press-details-title">{postTitle}</h1>
              <div className="section-press-details-author-publishDate">
                <span>{postDate}</span>
              </div>
            </Col>
          </Row>
          <Row className="section-press-details-contents" gutter={100} type="flex">
            <Col lg={16} md={16} sm={16} xs={24}>
              <StyledRichText content={content?.json} />
            </Col>
            <Col lg={8} md={8} sm={8} xs={24}>
              <SubscribeFormTitle>Solid advice delivered to your inbox.</SubscribeFormTitle>
              <STSubscribeForm
                buttonTitle="Subscribe"
                type="newsletter"
                className="blog-details--subscribe-form"
              />
              <MagazineDownload />
            </Col>
          </Row>
        </PressDetails>
      </SectionLayout>
      <CallToActionCards
        title="Related post"
        backgroundColor="White"
        buttonType="primary"
        buttonTitle="See more posts"
        buttonLinkTo="/press"
        cardType="Press"
        cardInfo={edges}
      />
    </WebsiteLayout>
  );
};

export default PressDetailsTemplate;

const PressDetails = styled.div`
  font-family: Sofia Pro;
  padding: 0 28px;

  .section-press-details-titles {
    .section-press-details-category {
      font-size: 16px;
      font-weight: 600;
      line-height: 110%;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: var(--blue-6);
      margin-bottom: 20px;
    }
    .section-press-details-title {
      font-size: 49px;
      font-weight: 600;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: var(--neutral-7);
      margin-bottom: 20px;
    }
    .section-press-details-author-publishDate {
      span {
        text-transform: uppercase;
        font-size: 13px;
        line-height: 150%;
        letter-spacing: 0.05em;
        color: var(--neutral-text-color);
        margin-right: 20px;
      }
      margin-bottom: 30px;
    }
  }

  .blog-details--subscribe-form {
    display: block;
    margin-bottom: 50px;
    input {
      width: 270px;
      height: 55px !important;
    }
    button {
      background-color: var(--blue-5);
      font-size: 20px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.01em;
      color: var(--white-color);
      font-weight: 300;
      width: 270px;
      margin-left: 0;
    }
  }

  @media (max-width: 1196px) {
    .blog-details--watch-full-video-form {
      width: 100%;
    }
  }
`;

const SubscribeFormTitle = styled.div`
  width: 270px;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 120%;
  letter-spacing: -0.02em;
  color: var(--neutral-6);
  margin-bottom: 20px;
`;

export const PressDetailsTemplateQuery = graphql`
  query PressPostBySlug($slug: String!) {
    contentfulPress(slug: { eq: $slug }) {
      pageTitle
      metaDescription {
        metaDescription
      }
      indexable
      canonicalUrl
      slug
      postTitle
      content {
        json
      }
      postDate(formatString: "MMMM DD, YYYY")
    }

    allContentfulPress(sort: { fields: [createdAt], order: DESC }, limit: 3) {
      edges {
        node {
          id
          slug
          postTitle
          metaDescription {
            metaDescription
          }
          postDate(formatString: "MMMM DD, YYYY")
        }
      }
    }
  }
`;
